<template>
  <div class="search-bar">
    <b-input-group>
        <b-form-input 
        :placeholder="searchPrompt" 
        v-model="searchTerm"
        @keyup.enter="enterClicked" >
        </b-form-input>
        <b-input-group-append>
          <b-button variant="primary" @click="clearInput">x</b-button>
        </b-input-group-append>
    </b-input-group>
    <div id="results">
      <b-list-group>
        <b-list-group-item 
        v-for="searchResult in searchResults" 
        v-bind:key="searchResult.id + searchResult.setName"
        v-on:click="navigateToResults(searchResult)"
        class="result">
            {{ searchResult.name }}
        </b-list-group-item>
      </b-list-group>
    </div>
  </div>
</template>

<script>

// import {producers, brands} from '@/assets/JSON/data.js'

export default {
  name: 'SearchBar',
  components: {

  },
  computed: {
    
  },
  mounted(){

  },
  props: {
    searchPrompt: String,
    firstDataSet: Array,
    secondDataSet: Array,
    firstDataSetName: String,
    secondDataSetName: String,
  },
  data () {
    return {
      searchTerm: '',
      searchResults: [],
      isActive: true,
    }
  },
  methods: {
    sortByName(a, b) {
      if (a.name < b.name){
        return -1;
      }

      if (a.name > b.name){
        return 1;
      }
      return 0;
    },
    enterClicked(event){
      if (this.searchResults[0]) {
        this.$emit("searchSelected", this.searchResults[0]);
        this.searchResults = [];
        this.clearInput();
      }
    },  
    clearInput(){
      this.searchTerm = '';
    },
    filterFirstDataset(term){
      if (term === ''){
        return [];
      }
      return this.firstDataSet.filter(item => {
        const normalizedName = item.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const normalizedSearchTerm = term.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return normalizedName.toLowerCase().includes(normalizedSearchTerm.toLowerCase());
      })
    },
    filterSecondDataset(term){
      if (term === ''){
        return [];
      }
      return this.secondDataSet.filter(item => {
        const normalizedName = item.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const normalizedSearchTerm = term.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return normalizedName.toLowerCase().includes(normalizedSearchTerm.toLowerCase());
      })
    },
    combineAndSort(firstSetList, secondSetList){
      firstSetList.sort(this.sortByName);
      secondSetList.sort(this.sortByName);
      const topResultsOfFirst = firstSetList.slice(0,6);
      const topResultsOfSecond = secondSetList.slice(0,6);

      const firstTopResultsLabeled = topResultsOfFirst.map(value => Object.assign(value, {setName: this.firstDataSetName}));
      const secondTopResultsLabeled = topResultsOfSecond.map(value => Object.assign(value, {setName: this.secondDataSetName}));

      return firstTopResultsLabeled.concat(secondTopResultsLabeled);
    },
    navigateToResults(searchResult){
      this.$emit("searchSelected", searchResult);
      this.searchResults = [];
      this.clearInput();
    }
  },
  watch: {
    searchTerm(newValue){
      const firstSetList = this.filterFirstDataset(newValue);
      const secondSetList = this.filterSecondDataset(newValue);
      this.searchResults = this.combineAndSort(firstSetList, secondSetList).sort(this.sortByName);
    }
  }
}
</script>

<style lang="scss" scoped>

input {
  font-family: "Optima";
}

a {
  font-size: 18px;
}

.result:active {
  background: rgb(233, 233, 233);
}

</style>
